import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.function.bind.js";
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/* eslint-disable max-len */

import * as React from 'react';
import CreditCardIconWrapper from '../CreditCardIconWrapper';

/** @no-props */

var IconVisa = function IconVisa(props) {
  return /*#__PURE__*/React.createElement(CreditCardIconWrapper, _extends({
    width: "32",
    height: "20",
    title: "Visa"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M0 0H32V20H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4B519",
    d: "M0 17.13H32V20H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2A2B6D",
    d: "M19.7259,5.8851 C20.5119,5.8851 21.1439,6.0571 21.6339,6.2341 L21.6339,6.2341 L21.2769,7.9071 C20.3629,7.4861 19.5569,7.5161 19.2649,7.5541 C18.6759,7.6311 18.4059,7.9321 18.3999,8.2151 C18.3809,9.1441 21.2669,9.2601 21.2579,11.3411 C21.2519,12.9801 19.8489,14.0391 17.7049,14.0391 C16.7949,14.0291 15.9149,13.8391 15.4379,13.6211 L15.4379,13.6211 L15.8079,11.8921 C16.2819,12.1131 16.8769,12.4061 17.9029,12.3901 C18.4879,12.3821 19.1169,12.1471 19.1229,11.6181 C19.1269,11.2731 18.8599,11.0251 18.0649,10.6381 C17.2929,10.2601 16.2669,9.6281 16.2789,8.4921 C16.2909,6.9571 17.7099,5.8851 19.7259,5.8851 Z M6.7422,6.0296 C7.1842,6.0296 7.5822,6.3236 7.6832,6.8336 L8.5432,11.3966 L10.6652,6.0296 L12.8082,6.0296 L9.5032,13.9156 L7.3472,13.9156 L5.7202,7.6216 C5.6212,7.2356 5.5352,7.0926 5.2352,6.9296 C4.7452,6.6626 3.9342,6.4136 3.2232,6.2586 L3.2712,6.0296 L6.7422,6.0296 Z M15.7237,6.0296 L14.0367,13.9156 L11.9967,13.9156 L13.6837,6.0296 L15.7237,6.0296 Z M26.8222,6.0299 L28.4702,13.9149 L26.5832,13.9149 L26.3362,12.7379 L23.7192,12.7379 L23.2942,13.9149 L21.1512,13.9149 L24.2132,6.6079 C24.3592,6.2569 24.6892,6.0299 25.0812,6.0299 L25.0812,6.0299 L26.8222,6.0299 Z M25.3802,8.1609 L24.3062,11.1219 L25.9982,11.1219 L25.3802,8.1609 Z M32,-3.15544362e-30 L32,2.869 L0,2.869 L0,-3.15544362e-30 L32,-3.15544362e-30 Z"
  }));
};
export default IconVisa;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@lmig/lmds-react-icons/dist/_esm/icons/Visa.js
// module id = 894
// module chunks = 0